import questionnaireStyles from './styles'
import {
   Box,
   Grid,
   Paper,
   FormControl,
   TextField,
   Button,
   Tooltip,
   IconButton
} from '@material-ui/core'
import iconQuestionnarie from '../../assets/icons/psychology_alt.png'
import { Controller, useForm, useFieldArray } from 'react-hook-form'
import { Autocomplete } from '@material-ui/lab'
import React, { useEffect, useState } from 'react'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import TooltipInputError from 'components/toolTip/ToolTipInputError'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import ReactQuill from 'react-quill'
import DeleteForever from 'images/icons/questionnarie/DeleteForever'
import { getFromApi, postToApi, putToApi } from 'actions'
import utils from 'utils/utils'

import 'react-quill/dist/quill.snow.css'
function FrequentQuestions() {
   const classes = questionnaireStyles()
   const [allActiveSubdomains, setAllActiveSubdomains] = useState([])
   const [errorQuill, setErrorQuill] = useState([{ error: false, message: '' }])
   const [allActiveApplications, setAllActiveApplications] = useState({})
   const [valueText, setValueText] = useState('')
   const [allRolesAndGroup, setAllRolesAndGroup] = useState([])
   const {
      watch,
      handleSubmit,
      control,
      setFields,
      getValues,
      setValue,
      register,
      formState: { errors, isValid }
   } = useForm({
      defaultValues: {
         subdomainId: '',
         applicationId: '',
         question: [
            {
               question: '',
               questionType: '',
               id: null
            }
         ]
      },
      mode: 'onChange'
   })

   const question = watch('question')
   useEffect(() => {
      register('question.questionType', { required: true, minLength: 15 })
   }, [register])
   const { fields, append, remove, update } = useFieldArray({
      control,
      name: 'question'
   })
   const handleRemoveQuestion = index => {
      console.log(index)
      remove(index)
      console.log(fields)
   }
   const validateQuill = (e, index) => {
      const value = getValues(`question.${index}.questionType`)
      const expresionRegular =
         /^((<p><br><\/p>|<h1><br><\/h1>|<h2><br><\/h2>|<h3><br><\/h3>|<br>|<ul><li><br><\/li><\/ul>|<ol><li><br><\/li><\/ol>)+)*$/
      const currentErrors = [...errorQuill]
      if (expresionRegular.test(value)) {
         currentErrors[index] = {
            error: true,
            message: 'El campo respuesta es obligatorio.'
         }
         setErrorQuill(currentErrors)
      } else {
         currentErrors[index] = {
            error: false,
            message: ''
         }
         setErrorQuill(currentErrors)
      }
      if (value.length > 1500) {
         currentErrors[index] = {
            error: true,
            message: 'El número de caracteres NO es válido.'
         }
         setErrorQuill(currentErrors)
      }
   }
   const appendQuestions = () => {
      const currentErrors = [...errorQuill]
      currentErrors.push({ error: false, message: '' })
      setErrorQuill(currentErrors)
      append({
         question: '',
         questionType: ''
      })
   }
   const selectedSubdomain = watch('subdomainId')
   const selectedApplication = watch('applicationId')
   // ------------- Fetch all Initial Active Subdomains  -----------------
   async function _getAllActiveSubdomains() {
      const url = `${process.env.REACT_APP_SUBDOMAIN_API}/subdomains/active`
      const searchedSubdomains = await getFromApi(url)
      setAllActiveSubdomains(searchedSubdomains)
   }

   const getAllActiveSubdomains = useApiRequest(
      _getAllActiveSubdomains,
      'Aplicaciones: Consultar Subdominios Activos'
   )

   const subdomainsGrouped = allActiveSubdomains.map(option => {
      const firstLetter = option.name[0].toUpperCase()
      return {
         firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
         ...option
      }
   })
   // ------------- Fetch all Initial Applications for subdomain  -----------------
   async function _getAllActiveApplications() {
      const url = `${process.env.REACT_APP_AUTHORIZATION_API}/user/subdomain/${
         watch('subdomainId')?.code
      }/applications`
      const activeApplications = await getFromApi(url)

      setAllActiveApplications(activeApplications)
   }

   const getAllActiveApplications = useApiRequest(
      _getAllActiveApplications,
      'Funcionalidades: Consultar Aplicaciones Activas'
   )

   useEffect(() => {
      getAllActiveSubdomains()
   }, [])
   useEffect(() => {
      getAllActiveApplications()
   }, [watch('subdomainId')])
   return (
      <>
         <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            style={{ minHeight: '100vh' }}
            className={classes.PageContainer}
         >
            <div
               style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignContent: 'center',
                  justifyContent: 'center',
                  padding: '0 7rem'
               }}
            >
               <Box
                  sx={{
                     width: '70%',
                     display: 'flex',
                     gap: '1rem',
                     justifyContent: 'space-between',
                     alignContent: 'center',
                     height: 'auto',
                     margin: '1rem'
                  }}
               ></Box>
               <Paper className={classes.paper}>
                  <Box
                     sx={{
                        width: '70%',
                        display: 'flex',
                        gap: '1rem',

                        alignContent: 'center',
                        alignItems: 'center',
                        height: '40px',
                        padding: '2rem 4rem'
                     }}
                  >
                     <div className={classes.iconQuestionnarie}>
                        <img src={iconQuestionnarie} alt="" />
                     </div>{' '}
                     <h3>Registrar preguntas frecuentes</h3>
                  </Box>
                  <form>
                     <Grid
                        style={{ padding: '1rem 7rem', marginBottom: '1.5rem' }}
                     >
                        <Box
                           sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '2.5rem',
                              width: '100%'
                           }}
                        >
                           <FormControl fullWidth>
                              <Controller
                                 name="subdomainId"
                                 control={control}
                                 rules={{
                                    required: {
                                       value: true,
                                       message:
                                          'El campo seleccionar subdominio es obligatorio.'
                                    }
                                 }}
                                 render={({
                                    field: { ref, onChange, ...field }
                                 }) => (
                                    <Autocomplete
                                       // value={subdomainObject}
                                       value={selectedSubdomain}
                                       options={subdomainsGrouped.sort(
                                          (a, b) =>
                                             -b.firstLetter.localeCompare(
                                                a.firstLetter
                                             )
                                       )}
                                       getOptionSelected={(option, value) =>
                                          option.id === value.id
                                       }
                                       getOptionLabel={option =>
                                          option.name
                                             ? utils.capitalizeFirstLetter(
                                                  option.name
                                               )
                                             : option?.name
                                       }
                                       groupBy={option => option.firstLetter}
                                       onChange={(_, data) => onChange(data)}
                                       // size="small"
                                       name="subdomainId"
                                       renderInput={params => (
                                          <TextField
                                             {...params}
                                             {...field}
                                             inputRef={ref}
                                             getOptionSelected={(
                                                option,
                                                value
                                             ) => option.id === value.id}
                                             label="Seleccionar subdominio *"
                                             variant="outlined"
                                             error={errors?.subdomainId}
                                             helperText={
                                                errors?.subdomainId
                                                   ? errors.subdomainId?.message
                                                   : ''
                                             }
                                             // error={invalid.subdomainId}
                                          />
                                       )}
                                    />
                                 )}
                              />
                           </FormControl>
                           <FormControl fullWidth>
                              <Controller
                                 name="applicationId"
                                 control={control}
                                 rules={{
                                    required: {
                                       value: true,
                                       message:
                                          'El campo seleccionar aplicación es obligatorio.'
                                    }
                                 }}
                                 render={({
                                    field: { ref, onChange, ...field }
                                 }) => (
                                    <Autocomplete
                                       // size="small"
                                       options={allActiveApplications}
                                       getOptionLabel={option => option.name}
                                       renderOption={option => (
                                          <span key={option.id}>
                                             {option.name}
                                          </span>
                                       )}
                                       value={selectedApplication}
                                       onChange={(_, data) => onChange(data)}
                                       renderInput={params => (
                                          <TextField
                                             {...params}
                                             {...field}
                                             inputRef={ref}
                                             label="Seleccionar aplicación *"
                                             variant="outlined"
                                             error={errors?.applicationId}
                                             helperText={
                                                errors?.applicationId
                                                   ? errors.applicationId
                                                        ?.message
                                                   : ''
                                             }
                                             // error={invalid.application}
                                          />
                                       )}
                                    />
                                 )}
                              />
                           </FormControl>
                        </Box>
                        {fields.map(function (question, index) {
                           return (
                              <section
                                 key={question.id}
                                 className="questionContainer"
                              >
                                 <Box
                                    sx={{
                                       display: 'flex',
                                       alignItems: 'center',
                                       gap: '1rem',
                                       width: '100%',
                                       marginTop: '20px'
                                    }}
                                 >
                                    <p
                                       style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          height: '100%',
                                          margin: '0',
                                          position: 'absolute',
                                          left: '-25px'
                                       }}
                                    >
                                       {index + 1}.
                                    </p>
                                    <Box
                                       sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '2.5rem',
                                          width: '100%'
                                       }}
                                    >
                                       <FormControl
                                          className={
                                             classes.formControlQuestion
                                          }
                                          fullWidth
                                       >
                                          <Controller
                                             name={`question.${index}.question`}
                                             control={control}
                                             rules={{
                                                required: {
                                                   value: true,
                                                   message:
                                                      'El campo pregunta es obligatorio'
                                                },
                                                maxLength: {
                                                   value: 1000,
                                                   message:
                                                      'El número de caracteres NO es válido. '
                                                }
                                             }}
                                             render={({
                                                field: {
                                                   value,
                                                   onChange,
                                                   onBlur
                                                },
                                                fieldState: { error }
                                             }) => (
                                                <TextField
                                                   label="Pregunta *"
                                                   value={value}
                                                   onChange={onChange}
                                                   onBlur={onBlur}
                                                   error={!!error}
                                                   variant="outlined"
                                                   multiline
                                                   InputProps={{
                                                      endAdornment:
                                                         error?.type ===
                                                            'maxLength' && (
                                                            <TooltipInputError
                                                               title={`El número permitido de caracteres es de máximo 1000.`}
                                                            />
                                                         )
                                                   }}
                                                   helperText={
                                                      error
                                                         ? error?.message
                                                         : ''
                                                   }
                                                />
                                             )}
                                          />
                                       </FormControl>
                                    </Box>
                                 </Box>
                                 <Box
                                    sx={{
                                       display: 'flex',
                                       alignItems: 'center',
                                       gap: '2.5rem',
                                       width: '100%',
                                       marginTop: '20px'
                                    }}
                                 >
                                    <FormControl
                                       className={classes.formControlQuestion}
                                       fullWidth
                                    >
                                       <Controller
                                          name={`question.${index}.questionType`}
                                          control={control}
                                          rules={{
                                             required: {
                                                value: true,
                                                message:
                                                   'El campo pregunta es obligatorio'
                                             }
                                          }}
                                          error={errors}
                                          render={({
                                             field: { value, onChange, onBlur },
                                             fieldState: { error }
                                          }) => (
                                             <ReactQuill
                                                placeholder="Respuesta *"
                                                className={`${classes.quill} ${
                                                   errorQuill[index].error
                                                      ? 'errorQuill'
                                                      : ''
                                                }`}
                                                onKeyUp={event =>
                                                   validateQuill(event, index)
                                                }
                                                theme="snow"
                                                value={value || ''}
                                                onChange={(
                                                   description,
                                                   delta,
                                                   source,
                                                   editor
                                                ) => onChange(description)}
                                                onBlur={onBlur}
                                             />
                                          )}
                                       />
                                    </FormControl>
                                 </Box>
                                 <p
                                    className={`${
                                       errorQuill[index].error
                                          ? 'errorQuillText'
                                          : ''
                                    }`}
                                 >
                                    {errorQuill[index].error
                                       ? `${errorQuill[index].message}`
                                       : ``}
                                 </p>
                                 <Tooltip
                                    title="ELIMINAR"
                                    placement="top"
                                    arrow
                                 >
                                    <div
                                       className={classes.buttonsDeleteQuestion}
                                    >
                                       <IconButton
                                          onClick={() =>
                                             handleRemoveQuestion(index)
                                          }
                                       >
                                          <DeleteForever color="#8A8FAB" />
                                       </IconButton>
                                    </div>
                                 </Tooltip>
                              </section>
                           )
                        })}
                     </Grid>
                     <Tooltip
                        title="AGREGAR OTRA PREGUNTA"
                        placement="top"
                        arrow
                        className={classes.AddQuestionTooltip}
                     >
                        <IconButton>
                           <AddCircleIcon
                              color="primary"
                              className={classes.AddQuestion}
                              fontSize="large"
                              // onClick={() => setQuestionsList([...questionsList, '1'])}
                              onClick={() => appendQuestions()}
                           />
                        </IconButton>
                     </Tooltip>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'center',
                           alignContent: 'center',
                           height: '70px',
                           width: '100%',
                           background: '#3264DC0F 0% 0% no-repeat'
                        }}
                     >
                        <div
                           style={{
                              width: '100%',
                              display: 'flex',
                              gap: '1rem',
                              justifyContent: 'flex-end',
                              alignContent: 'center',
                              padding: '1rem 7rem'
                           }}
                        >
                           <Button variant="outlined" color="primary">
                              CANCELAR
                           </Button>
                           <Button
                              variant="contained"
                              color="primary"
                              type="submit"
                           >
                              GUARDAR
                           </Button>
                        </div>
                     </Box>
                  </form>
               </Paper>
            </div>
         </Grid>
      </>
   )
}

export default FrequentQuestions
